import React from 'react';

import { MARKETS } from 'constants/filter';
import { Markets } from 'constants/markets';
import { useTranslationsContext } from 'contexts/translationsContext';
import { useIsLessThan } from 'fxs-utils';

import { IconCheck } from '@tabler/icons-react';

import { RowTypes } from './RowType';
import {
	FXSFilterMarketBtn,
	FXSFilterMarketWrapper,
	FXSFilterModalRow,
	FXSFilterTitle
} from './styles';

const MarketRow = ({ activeTrades, state, handleClick }: RowTypes) => {
	const isLessThan833 = useIsLessThan(833);
	const { t } = useTranslationsContext();

	return (
		<FXSFilterModalRow activeTrade={activeTrades}>
			<FXSFilterTitle isLessThan833={isLessThan833}>
				{t('markets')}
			</FXSFilterTitle>
			<FXSFilterMarketWrapper>
				{Markets.map((m) => (
					<FXSFilterMarketBtn
						key={m.id}
						checked={state?.markets?.includes(m.value)}
						disabled={activeTrades}
						onClick={(e) =>
							handleClick(e, m.value, MARKETS, null, false)
						}
					>
						{state?.markets?.includes(m.value) && (
							<IconCheck stroke={2} />
						)}
						{m.value}
					</FXSFilterMarketBtn>
				))}
			</FXSFilterMarketWrapper>
		</FXSFilterModalRow>
	);
};

export default MarketRow;
